<template>
  <div class="pageBottom">
    <div class="flex">
      <!-- <img class="bottomLogo"
                 src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/webBottomLogo.png">
            <div class="textRight">
                <div><a href="tel: +86 21 5830 6270">{{currentLanguage == 0 ? 'Asia' : '亚洲'}}：+86 21 5830 6270</a></div>
                <div class="marginTop10"><a href="tel: +1 208 809 7117">{{currentLanguage == 0 ? 'USA' : '美国'}}：+1 208 809 7117</a></div>
                <div class="marginTop10">
                    <a class="textEmail" href="mailto: team@holdendata.com">{{currentLanguage == 0 ? 'E-mail' : '邮箱'}}：team@holdendata.com</a>
                </div>
            </div> -->
      <div class="bottomli">
        <div class="img"><img src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/webLogoEN.png"></div>

        <div class="link">
          <div>
            <router-link target="_blank" :to="{path:'/privacyPolicy'}">{{currentLanguage==0?"Privacy Policy":"隐私政策"}}</router-link>
          </div>
          <div>
            <router-link target="_blank" :to="{path:'/terms'}">{{currentLanguage==0?"Terms of Use":"使用条款"}}</router-link>
          </div>

          <div @click="Changecookies">{{currentLanguage==0?"Cookies Setting":"Cookies设置"}}</div>
        </div>
      </div>

      <div class="bottomli flex1">
        <div class="title">
          {{ currentLanguage == 0 ? 'Asia' : '亚洲' }}
        </div>
        <div class="desc">
          <div class="desc_li">
            <div class="desc_litop">
              <img class="tel" src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/bottom_tel.png" alt="">
              {{ currentLanguage == 0 ? 'Phone number' : '电话' }}
            </div>
            <div class="desc_libottom">
              +86 21 5830 6270
            </div>

          </div>
          <!-- <div class="desc_li">
            <div class="desc_litop">
              <img class="address" src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/bottom_address.png" alt="">
              {{ currentLanguage == 0 ? 'Address' : '地址' }}
            </div>
            <div class="desc_libottom">
              {{ currentLanguage == 0 ? 'Shanghai China' : '中国上海' }}
            </div>
          </div> -->
          <div class="desc_li">
            <div class="desc_litop">
              <img class="email" src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/bottom_email.png" alt="">
              {{ currentLanguage == 0 ? 'Email' : '邮箱' }}
            </div>
            <div class="desc_libottom">
              <!-- team@holdendata.com -->
              <a style="color: #fff;" href="mailto:team@holdendata.com" target="_blank" rel="noopener">team@holdendata.com</a>
            </div>
          </div>
        </div>
      </div>

      <div class="bottomli flex1">
        <div class="title">
          {{ currentLanguage == 0 ? 'USA' : '美国' }}
        </div>
        <div class="desc">
          <div class="desc_li">
            <div class="desc_litop">
              <img class="tel" src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/bottom_tel.png" alt="">
              {{ currentLanguage == 0 ? 'Phone number' : '电话' }}
            </div>
            <div class="desc_libottom">
              +1 208 809 7117
            </div>
          </div>
          <!-- <div class="desc_li">
            <div class="desc_litop">
              <img class="address" src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/bottom_address.png" alt="">
              {{ currentLanguage == 0 ? 'Address' : '地址' }}
            </div>
            <div class="desc_libottom">
              Boise ID USA
            </div>
          </div> -->
          <div class="desc_li">
            <div class="desc_litop">
              <img class="email" src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/bottom_email.png" alt="">
              {{ currentLanguage == 0 ? 'Email' : '邮箱' }}
            </div>
            <div class="desc_libottom">
              <!-- team@holdendata.com -->
              <a style="color: #fff;" href="mailto:team@holdendata.com" target="_blank" rel="noopener">team@holdendata.com</a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- <div class="li">
      <div class="social">
        <div>
          <a href="#"><img src="@/assets/img/appa.png"></a>
        </div>
        <div>
          <a href="#"><img src="@/assets/img/media1.png"></a>
        </div>

        <div>
            <a href="#"><img src="@/assets/img/media3.png"></a>
          </div>

      </div>
    </div> -->
    <div class="bottomLine" />
    <div class="flexCenter textCompanyInfo">
      <!--            <div>上海浩顿英菲市场信息咨询有限公司</div>-->
      <div>Copyright © 2022 - 2023 Holden. All rights reserved.</div>
      <a href="http://www.beian.miit.gov.cn" target="_blank">沪ICP备10019317号-2</a>
    </div>
    <!-- 提示框 -->
    <transition name="el-zoom-in-top">
      <div class="tipBox" v-show="showTip" @click="showTip=!showTip">
        <div class="tipCon" v-if="currentLanguage">
          <img :src="tipStatus?'https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/success-icon.png':'https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/error-icon.png'">
          <h4>{{ tipStatus?'提交成功':'提交失败' }}</h4>
          <div class="text" v-if="tipStatus">
            感谢您订阅Holden Newsletter，我们会定期与您分享行业动态、研究案例等。
          </div>
          <p v-else>
            请直接拨打底部电话和我们联系。
          </p>
        </div>
        <div class="tipCon" v-else>
          <img :src="tipStatus?'https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/success-icon.png':'https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/error-icon.png'">
          <h4>{{ tipStatus?'success':'error' }}</h4>
          <div class="text" v-if="tipStatus">
            <p>Thank you for signing up to the Holden newsletter, </p>
            <p>we will regularly share you industry updates and case studies!</p>
          </div>
          <p v-else>
            Please call us directly at the bottom.
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { editSubscribeMail } from "@/api/api";
const defaultForm = {
  mail: "",
  email: ""
};
export default {
  props: {
    changecookies: Function
  },
  data() {
    return {
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      showTip: false,
      tipStatus: true,
      rules: {
        mail: [
          { required: true, message: "请填写您的邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: ["blur"] }
        ],
        email: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly", trigger: ["blur"] }
        ]
      }
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    // $route(val, old) {
    //   this.changeRoute();
    // }
  },
  computed: {
    currentLanguage() {
      return Number(this.$store.state.lang);
    }
  },
  methods: {
    btn(path) {
      this.$router.push({
        path
      });
    },
    Changecookies() {
      this.changecookies(true);
    },
    // changeRoute() {
    //   this.$refs["ruleForm"].clearValidate();
    // },
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          let ruleForm = {
            mail: _this.currentLanguage == 0 ? _this.ruleForm.email : _this.ruleForm.mail
          };
          editSubscribeMail(ruleForm).then(res => {
            if (res.code == 10000) {
              _this.showTip = true;
              _this.tipStatus = true;
              _this.ruleForm = JSON.parse(JSON.stringify(defaultForm));
              _this.$refs[formName].clearValidate();
            } else {
              _this.showTip = true;
              _this.tipStatus = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.marginTop10 {
  margin-top: 10px;
}
.pageBottom {
  background: #333333;
  padding: 100px;
  color: #ffffff;
  .li{
    display: flex;
    justify-content: center;
  }
  .social {
    display: flex;
    width: 50%;
    justify-content: space-around;
    img {
      width: 100px;
      // width: auto;
      // height: 30px;
      margin-top: 20px;
      // margin-right: 50px;
    }
  }
  .flex {
    display: flex;
    flex-wrap: wrap;

    .bottomli {
      &:nth-child(1) {
        margin: auto 0;
        width: 45%;
        margin-bottom: 60px;
        img {
          width: 400px;
        }
        .link {
          display: flex;
          div {
            cursor: pointer;
            margin-top: 20px;
            padding: 0 20px;
            border-left: 1px solid #fff;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(3) {
        width: 20%;
      }
      &:nth-child(4) {
        .social {
          div {
            width: 150px;
            height: 50px;
            // border-radius: 50%;
            overflow: hidden;
            margin-bottom: 30px;
            img {
              width: 100%;
            }
          }
        }
      }

      &.last {
        //  width: 200px;
        width: 75%;
      }
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #ffffff;
        position: relative;
        padding-bottom: 11px;
        &::after {
          position: absolute;
          content: "";
          left: 0;
          bottom: 0;
          width: 50px;
          height: 3px;
          background: #fff;
        }
      }
      @media screen and (max-width: 576px) {
        .title {
          font-size: 30px;
        }
      }
      .desc {
        .desc_li {
          margin-top: 20px;
          font-size: 15px;
          .desc_litop {
            font-weight: bold;
            .tel {
              width: 11px;
              height: 11px;
              margin-right: 6px;
            }
            .address {
              width: 10px;
              height: 11px;
              margin-right: 6px;
            }
            .email {
              width: 10px;
              height: 11px;
              margin-right: 6px;
            }
          }
          .desc_libottom {
            padding-left: 3px;
            margin-top: 3px;
          }
        }
        .right_email {
          margin-top: 11px;
          .el-form-item__label {
            color: #fff;
            font-size: 15px;
            font-weight: normal;
            font-weight: bold;
          }
        }
      }
    }
    @media screen and (max-width: 576px) {
      .bottomli {
        &:nth-child(1) {
          width: 81%;
        }
      }
    }
    .bot {
      p.mailtxt {
        margin: 0;
        font-size: 15px;
        color: #efeeee61;
      }
      .el-input__inner {
        background: #fafafa;
        border: 1px solid #e6e6e6;
        border-radius: 5px;
        font-size: 15px;
      }
      .button {
        margin-top: 17px;
        background: #217df6;
        font-size: 13px;
        color: #fff;
        border-radius: 3.3px;
        text-align: center;
        // width:90px;
        // height: 34px;
        width: 50%;
        padding: 10px 0;
        // line-height:34px;
        cursor: pointer;
      }
    }
  }
  .bottomLine {
    background: #999999;
    height: 1px;
    width: 100%;
    margin: 67px auto 37px;
  }

  .textCompanyInfo {
    line-height: 15px;
    font-size: 10px;

    a {
      // margin: 0 15px;
      color: #58a5ff;
    }
  }
}
@media screen and (max-width: 576px) {
  * {
    font-size: 35px;
  }
  .pageBottom {
    .textCompanyInfo {
      line-height: 60px;

      display: flex;
      flex-wrap: wrap;
      div {
        text-align: center;
        width: 100%;
      }
    }
  }
}
</style>
